import React from 'react';
import { CalendarIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Card } from '../components/ui/Card';
import { goals } from '../data/insights';
import { useLocale } from '../contexts/LocaleContext';
export function Goals() {
  const {
    t,
    tl
  } = useLocale();
  return <div className="px-2 pb-2" data-id="element-2692" data-mp="v3v7yubbx12i">
      <PageHeader title={t('stats.goals.title')} subtitle={t('goals.subtitle')} showBack data-id="element-2693" data-mp="v2ts8cjdbqeg" />

      <ul className="space-y-2" data-id="element-2694" data-mp="19rg7yfcwqk67">
        {goals.map(goal => {
        const pct = Math.min(100, Math.round(goal.current / goal.target * 100));
        return <li key={goal.id} data-id="element-2695" data-mp="1itz5ql1u66ll">
              <Card className="p-2" data-id="element-2696" data-mp="1iswhylzt8k9w">
                <div className="flex items-baseline justify-between gap-2" data-id="element-2697" data-mp="1esdnek6j9040">
                  <p className="min-w-0 text-[13.5px] font-medium text-deep" data-id="element-2698" data-mp="1epzy6ryjai4d">
                    {tl(goal.title)}
                  </p>
                  <p className="bee-num shrink-0 text-[12px] font-bold text-gold-deep" data-id="element-2699" data-mp="3gjz2uuh5i183">
                    {pct}%
                  </p>
                </div>

                <p className="bee-num mt-1 text-[12px] text-muted" data-id="element-2700" data-mp="18fyxvd2clxx1">
                  {goal.current} {t('goals.of')} {goal.target} {tl(goal.unit)}
                </p>

                <div className="mt-2 h-[7px] w-full overflow-hidden rounded-pill bg-sand-deep" data-id="element-2701" data-mp="1ifg1loy1i1qd">
                  <span className="block h-full rounded-pill bg-gold" style={{
                width: `${pct}%`
              }} data-id="element-2702" data-mp="1n7pvth66tnyg" />
                </div>

                {goal.deadline && <p className="mt-2 flex items-center gap-1 text-[11px] text-muted" data-id="element-2703" data-mp="1w5t8dnz73ae4">
                    <CalendarIcon size={12} aria-hidden="true" data-id="element-2704" data-mp="2178tfg1dhgwi" />
                    {tl(goal.deadline)}
                  </p>}
              </Card>
            </li>;
      })}
      </ul>

      <p className="mt-2 px-1 text-[11px] leading-snug text-muted" data-id="element-2705" data-mp="6uiyqw36k3o2">
        {t('goals.note')}
      </p>
    </div>;
}